import { type FC } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Formik, Form } from 'formik';
import {
  UiButton,
  type UiHStackProps, UiStack
} from '@/lib/ui';
// import Industries from './Industries';
import BaseFormFieldGroup from '@/base/Form/FieldGroup';
import BaseFormInputField from '@/base/Form/InputField';
import { type FieldMetadataInput } from './Field';
import BaseFormSelectField from '@/base/Form/SelectField';
import { validateLabelFields } from '@/lib/util';

export interface FieldInputFormProps extends UiHStackProps {
  onSave: (fieldMetadata: FieldMetadataInput) => void
  fieldMetadata?: FieldMetadataInput
}

interface FieldAttributes {
  label: string
  length?: number
  helpText?: string
  isRequired: boolean
}

interface Errors {
  label?: string
  length?: string
  helpText?: string
  isRequired?: string
}

const FieldInputForm: FC<FieldInputFormProps> = ({
  fieldMetadata = undefined,
  onSave
}) => {
  const initValues: FieldAttributes = {
    label: fieldMetadata?.label ?? '',
    length: fieldMetadata?.length ?? undefined,
    helpText: fieldMetadata?.helpText ?? '',
    isRequired: fieldMetadata?.isRequired ?? false
  };

  return (
    <Formik
      initialValues={initValues}
      validateOnChange={false}
      validateOnBlur={false}
      validate={(values: FieldAttributes): Errors => {
        const errors: Errors = {};
        const labelError = validateLabelFields(values.label);
        if (labelError) {
          errors.label = labelError;
        }
        return errors;
      }}
      onSubmit={async (
        values: FieldAttributes
        // { setSubmitting }: FormikHelpers<FieldAttributes>
      ) => {
        // alert(JSON.stringify(values, null, 2));
        // setSubmitting(false);
        // const length = parseInt(values.length ?? -1, 10);
        if (fieldMetadata) {
          onSave({
            ...fieldMetadata,
            ...{
              type: 'input',
              label: values.label,
              length: values.length,
              helpText: values.helpText,
              isRequired: values.isRequired,
              canDelete: true,
              canEdit: true
            }
          });
        } else {
          onSave({
            id: uuidv4().replaceAll('-', ''),
            type: 'input',
            label: values.label,
            length: values.length,
            helpText: values.helpText,
            isRequired: values.isRequired,
            canDelete: true,
            canEdit: true
          });
        }
      }}
    >
      <Form
        style={{
          display: 'flex',
          marginTop: 0
        }}
      >
        <UiStack flexGrow={1}>
          <BaseFormFieldGroup>
            <BaseFormInputField
              name={'label'}
              label={'Field label'}
            />
            <BaseFormInputField
              name={'length'}
              type={'number'}
              label={'Character limit'}
              isRequired={false}
              helperText={'Max number of charactors allowed for the field (e.g. 125). Leave empty if there is no limit.'}
            />
            <BaseFormInputField
              name={'helpText'}
              label={'Help text'}
              isRequired={false}
              helperText={'This the text you want to show underneath the field to provide some context or examples.'}
            />
            <BaseFormSelectField
              name={'isRequired'}
              label={'Is this field mandatory?'}
              options={[
                { value: true, label: 'Yes' },
                { value: false, label: 'No' }
              ]}
            />
          </BaseFormFieldGroup>
          <UiStack flexDirection={'row-reverse'} pt={12}>
            <UiButton px={8} size={'lg'} shadow={'base'} colorScheme={'primary'} type={'submit'}>
              Save
            </UiButton>
          </UiStack>
        </UiStack>
      </Form>
    </Formik>
  );
};

export default FieldInputForm;
